module.exports = __webpack_public_path__ + "4f12f22b96f812ab0c6491e8b1764b09.jpg";